module.exports = __webpack_public_path__ + "static/img/nubank.7b9f6c71.svg";